import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import Container from "../components/common/Container";
import Button from "../components/common/Button";
import { useParams } from "react-router-dom";
import { CartContext } from "../ContextAPI";
import Layout from "../components/common/Layout";

const ProductDetails = () => {
   const { handleInc } = useContext(CartContext);
  const {id} = useParams();
  const [product, setProduct] = useState(null);
  const [count, setCount] = useState(1);
  const [error, setError] = useState('');

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(`https://fakestoreapi.com/products/${id}`);
        setProduct(response.data);
      } catch (error) {
        setError('We could not load this product. Please try again.');
      }
    };
    getData();
  }, [id]);

  const handleAddToCart = () => {
  if (!product) return;
  handleInc({ ...product, qty: count });
};
  return (
    <Layout><Container className="py-10 sm:py-16">
      {error && <p className="rounded-lg bg-rose-50 p-4 text-rose-700">{error}</p>}
      {!product && !error && <p className="text-slate-500">Loading product…</p>}
      {product && <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
        <div className="flex min-h-[380px] items-center justify-center rounded-2xl border border-slate-200 bg-white p-8 sm:min-h-[520px]"><img className="max-h-[440px] w-full object-contain" src={product.image} alt={product.title} /></div>
        <div className="flex flex-col justify-center"><p className="text-sm font-semibold capitalize text-indigo-600">{product.category}</p><h1 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">{product.title}</h1><p className="mt-5 text-sm font-medium text-amber-600">★ {product.rating?.rate || 'N/A'} <span className="text-slate-400">({product.rating?.count || 0} reviews)</span></p><p className="mt-5 text-3xl font-bold text-slate-900">${product.price}</p><p className="mt-6 leading-7 text-slate-600">{product.description}</p>
        <div className="mt-8 flex items-center gap-3"><button aria-label="Decrease quantity" className="h-11 w-11 rounded-lg border border-slate-300 text-lg hover:bg-slate-100" onClick={() => setCount((value) => Math.max(1, value - 1))}>−</button><span className="w-10 text-center font-semibold">{count}</span><button aria-label="Increase quantity" className="h-11 w-11 rounded-lg border border-slate-300 text-lg hover:bg-slate-100" onClick={() => setCount((value) => value + 1)}>+</button></div>
        <Button title="Add to cart" className="mt-5 w-full sm:w-56" onClick={handleAddToCart} /></div>
      </div>}
    </Container></Layout>
  );
};

export default ProductDetails;
